export type FollowUpBucket = 'overdue' | 'today' | 'upcoming' | 'completed' | 'cancelled' | 'open';

export function followUpBucket(
  dueAt: Date | string,
  completedAt?: Date | string | null,
  cancelledAt?: Date | string | null,
  now = new Date(),
): FollowUpBucket {
  if (completedAt) return 'completed';
  if (cancelledAt) return 'cancelled';
  const due = new Date(dueAt);
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const tomorrow = new Date(start);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (due < start) return 'overdue';
  if (due < tomorrow) return 'today';
  return 'upcoming';
}

export function phoneHref(value: string) {
  return `tel:${value.replace(/[^+\d]/g, '')}`;
}

export function whatsappHref(value: string) {
  return `https://wa.me/${value.replace(/\D/g, '')}`;
}

export function formatMinorAmount(amountMinor: number, currencyCode = 'INR') {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currencyCode }).format(
    amountMinor / 100,
  );
}
